import type { TokenDefinition, } from "@bracket/chainography/types";

export const USDT: TokenDefinition<"USDT", "USDT"> = {
	name: "USDT TEST TOKEN",
	symbol: "USDT",
	label: "USDT",
	chainId: 200810,
	address: "0xab40fe1dae842b209599269b8dafb0c54a743438",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/tethernew_32.svg",
	fees: [],
	swapto: false,
	stakable: true,
	parity: false,
	escrow: false,
	stablecoin: false,
	denominable: true,
} as const;

export const USDC: TokenDefinition<"USDC", "USDC"> = {
	name: "USDC TEST TOKEN",
	symbol: "USDC",
	label: "USDC",
	chainId: 200810,
	address: "0x209ba92b5cc962673a30998ed7a223109d0be5e8",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/usdc_ofc_32.svg",
	fees: [],
	swapto: false,
	stakable: true,
	parity: false,
	escrow: false,
	stablecoin: false,
	denominable: true,
} as const;

export const WBTC: TokenDefinition<"WBTC", "wBTC"> = {
	name: "wrapped BTC",
	symbol: "WBTC" as const,
	label: "wBTC",
	chainId: 200810,
	address: "0x3e57d6946f893314324c975aa9cebbdf3232967e",
	logoURI: "https://etherscan.io/token/images/wrappedbtc_ofc_32.svg",
	decimals: 18,
	parity: false,
	swapto: false,
	escrow: false,
	platform: false,
	platform_supply: false,
	denominable: true,
	stablecoin: false,
};

export const BTC: TokenDefinition<"BTC", "BTC"> = {
	name: "bitcoin",
	symbol: "BTC" as const,
	label: "BTC",
	chainId: 1,
	address: WBTC.address,
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/wrappedbtc_ofc_32.svg",
	fees: [],
	swapto: false,
	swapable: true,
	parity: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};


export const BRC: TokenDefinition<"BRC", "BRC"> = {
	disabled: true,
	name: "BRC TEST TOKEN",
	symbol: "BRC",
	label: "BRC",
	chainId: 200810,
	address: "0xf4340cf5f3891a3827713b33f769b501a0b5b122",
	decimals: 18,
	logoURI: "https://static.okx.com/cdn/assets/imgs/248/D1EF798953119DE0.png?x-oss-process=image/resize,w_72,h_72,type_6/ignore-error,1",
	fees: [],
	swapto: false,
	stakable: true,
	parity: false,
	escrow: false,
	stablecoin: false,
	denominable: false,
} as const;
